<div class="registry-form-preview">
  <div class="preview-content">
    <div class="preview-content-item enhance-profile">
      @if (enhanceBenificiaryDetails()?.beneficiaryType === 'NEW') {
        @for (item of createBeneficiaryFields; track $index) {
          <div class="enhance-profile-details-item">
            <div class="profile-dot"></div>
            <div>{{ item }}</div>
          </div>
        }
      }
      @if (enhanceBenificiaryDetails()?.enhanceProfileDetails) {
        @for (item of enhanceBenificiaryDisplayData(); track $index) {
          <div class="enhance-profile-details-item">
            @if ($index === 0) {
              <rkt-icon name="beneficiary"></rkt-icon>
            }
            <div class="profile-dot"></div>
            <div>{{ item }}</div>
          </div>
        }
      }
      @if (enhanceBenificiaryDetails()?.documentTypes?.length) {
        @for (item of enhanceBenificiaryDetails()?.documentTypes; track $index; let docIndex = $index) {
          @if (item === 'other' && enhanceBenificiaryDetails()?.otherDocuments?.length) {
            @for (document of enhanceBenificiaryDetails()?.otherDocuments; track $index) {
              <div class="enhance-profile-details-item other-document-preview">
                @if (docIndex === 0 && $index === 0) {
                  <rkt-icon name="document"></rkt-icon>
                }
                <div class="profile-dot"></div>
                <div>
                  <div class="other-document-name">{{ document.name }}</div>
                  <div class="other-document-description">{{ descriptionText(document.description) }}</div>
                </div>
              </div>
            }
          } @else {
            <div class="enhance-profile-details-item">
              @if (docIndex === 0) {
                <rkt-icon name="document"></rkt-icon>
              }
              <div class="profile-dot"></div>
              <div>{{ item.replace('-', ' ') | titlecase }}</div>
            </div>
          }
        }
      }
    </div>
  </div>

  <button class="preview-edit" [disabled]="isEditDisabled()" (click)="expandRow.emit()">
    <rkt-icon name="edit"></rkt-icon>
  </button>
</div>
